import React, { useState } from "react";
import { Popover, Typography } from "@mui/material";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const StatusPopover = ({ block_status }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <FiberManualRecordIcon
        sx={{
          fontSize: 16,
          color: block_status === 1 ? "green" : "#f50a0a",
          cursor: "pointer",
          padding: "4px",
          backgroundColor: block_status === 1 ? "#d2f7d5" : "#fbdbdb",
          borderRadius: "4px",
        }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableRestoreFocus
        sx={{ pointerEvents: "none" }}
      >
        <Typography sx={{ padding: '2px', fontSize: 10 }}>
          {block_status === 1 ? "Active" : "Inactive"}
        </Typography>
      </Popover>
    </div>
  );
};

export default StatusPopover;
